import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, MapPin, Clock } from 'lucide-react';
import { OrnateDivider } from './Decorations';
export function EventDetails() {
  const details = [{
    icon: <Calendar className="w-6 h-6 text-carrot" data-id="element-43" />,
    label: 'The Date',
    value: 'Friday, 15th May 2026',
    subtext: 'Tomorrow Morning'
  }, {
    icon: <MapPin className="w-6 h-6 text-carrot" data-id="element-44" />,
    label: 'The Venue',
    value: 'Lillian Prime MS Centre',
    subtext: 'Derby, UK'
  }, {
    icon: <Clock className="w-6 h-6 text-carrot" data-id="element-45" />,
    label: 'The Schedule',
    value: 'Doors: 9:30 AM',
    subtext: 'Showtime: 10:00 AM Sharp'
  }];
  return <section className="py-20 px-4 relative z-10 bg-parchment-dark/60 border-y-2 border-gold/30" data-id="element-46">
      <div className="max-w-5xl mx-auto" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12" data-id="element-48">
          {details.map((detail, index) => <div key={index} className="flex flex-col items-center text-center group" data-id="element-49">
              <div className="w-16 h-16 rounded-full border border-carrot/30 bg-parchment flex items-center justify-center mb-6 group-hover:border-carrot group-hover:box-glow-carrot transition-all duration-500 shadow-sm" data-id="element-50">
                {detail.icon}
              </div>
              <h3 className="text-gold uppercase tracking-[0.15em] text-sm mb-2 font-sans font-medium" data-id="element-51">
                {detail.label}
              </h3>
              <p className="text-xl md:text-2xl font-serif text-velvet mb-1" data-id="element-52">
                {detail.value}
              </p>
              <p className="text-velvet/60 text-sm font-light italic" data-id="element-53">
                {detail.subtext}
              </p>
            </div>)}
        </motion.div>

        <div className="mt-16" data-id="element-54">
          <OrnateDivider data-id="element-55" />
        </div>
      </div>
    </section>;
}